<template>
  <div class="categories-list">
    <div
      class="category-name"
      :class="{'selected': categoryId === null}"
      @click="goToCategoryDetail()"
    >
      All
    </div>
    <div
      @click="goToCategoryDetail(category.id)"
      v-for="category in categories"
      :key="category.id"
      :class="{
        'selected': categoryId === category.id,
      }"
      class="category-name"
    >
      {{ category.shortName }}
    </div>
  </div>
</template>

<script>
import CategoryApi from '@/api/category'
import Utils from '@/util'

export default {
  components: {
  },
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      categories: [],
      clickingToScroll: null,
    }
  },
  created() {
    this.getAllCategories()
  },
  methods: {
    async getAllCategories() {
      const res = await CategoryApi.getAllCategories()
      this.categories = res.data
    },
    goToCategoryDetail(id) {
      if (id) {
        this.$router.push(`/apps/template-library/category/${id}`)
        Utils.gaTrackEvent('Template Library > Open Category', 'Open Category', '', id)
      } else {
        this.$router.push('/apps/template-library')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.category-name {
  padding: 8px 16px;
  border-radius: 40px;
  background-color: #fff;
  border: 1px solid #D3D7E1;
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.3s ease;
  display: inline-block;
  margin-bottom: 8px;

  &.active, &:hover, &:focus {
    border-color: #348EF6;
    color: #348EF6;
  }

  &.selected, &:focus {
    background-color: #348EF6;
    color: #fff;
    border-color: #348EF6;
  }
}

.categories-list {
  margin-bottom: 16px;
}

@media (max-width: 960px) {
  .categories-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space:nowrap;
    padding: 2px;
  }
}
</style>
